import { render, staticRenderFns } from "./OrganizationOwnerChangeModal.vue?vue&type=template&id=545ac0de&scoped=true"
import script from "./OrganizationOwnerChangeModal.vue?vue&type=script&lang=js"
export * from "./OrganizationOwnerChangeModal.vue?vue&type=script&lang=js"
import style0 from "./OrganizationOwnerChangeModal.vue?vue&type=style&index=0&id=545ac0de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545ac0de",
  null
  
)

export default component.exports